import { redirect } from "@tanstack/react-router";

import type { AuthUserJWT, User } from "@/types/auth";

import { isElevatedRole } from "@/utils/roleAccess";

export function canAccessBesties(
  role: User["role"] | null | undefined,
  orgType?: AuthUserJWT["org_type"],
) {
  return orgType === "agency" || isElevatedRole(role);
}

export function redirectUnauthorizedBestiesAccess(
  role: User["role"] | null | undefined,
  siteId: string,
  orgType?: AuthUserJWT["org_type"],
) {
  if (!canAccessBesties(role, orgType)) {
    throw redirect({
      to: "/dragon-tiles/$siteId",
      params: { siteId },
    });
  }
}
